//Paquetes NPM de GYF. 
import { LogHelper } from 'com-gyf-webcore-loghelper';
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import { ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH } from '../../ClientSearch/actions/Actions'

import SolicitudManager from '../../../Common/Managers/SolicitudManager';
import ClienteManager from '../../../Common/Managers/ClienteManager';
import ProcessManager from '../../../Common/Managers/ProcessManager';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

let userFeatures = [];
let _dispatch = null;
let _tarjetas;
let _vistaCliente;
let _executionContext;
/**/
let _routtingState = undefined;

// ACTION TYPES
export const GET_SCREEN_DATA = 'GET_SCREEN_DATA';
export const GET_SCREEN_DATA_RESULT = 'GET_SCREEN_DATA_RESULT';
export const ROUTE_TO_NEXT = 'ROUTE_TO_NEXT';
export const ROUTE_TO_PREVIOUS = 'ROUTE_TO_PREVIOUS';
export const ROUTE_TO_CANCEL = 'ROUTE_TO_CANCEL';
export const ROUTE_TO_ADMINISTRADORA = 'ROUTE_TO_ADMINISTRADORA';
export const ROUTE_TO_TARJETAS = 'ROUTE_TO_TARJETAS';
export const ROUTE_TO_TIPO_EMPRESA = 'ROUTE_TO_TIPO_EMPRESA';
export const ROUTE_TO_EMPRESA = 'ROUTE_TO_EMPRESA';
export const ROUTE_TO_CUENTA = 'ROUTE_TO_CUENTA';
export const ROUTE_TO_PRODUCTO = 'ROUTE_TO_PRODUCTO';
export const ROUTE_TO_CONFIRMACION = 'ROUTE_TO_CONFIRMACION';
export const SAVE_REQUEST = 'SAVE_REQUEST';
export const FINISH_REQUEST = 'FINISH_REQUEST';
export const SHOW_SAVE_STATUS = 'SHOW_SAVE_STATUS';
export const STOP_SPINNER = 'STOP_SPINNER';
export const FUNCTION_CODE_CREATE = 'Alta';
export const FUNCTION_CODE_QUERY = 'Consulta';
export const FUNCTION_CODE_DISTRIBUTION = 'Distribucion';
export const RESET_STATE_CONFIRMACION = 'RESET_STATE_CONFIRMACION';
export const ROUTE_TO_VISTA_CLIENTE_FROM_CONFIRMACION = 'ROUTE_TO_VISTA_CLIENTE_FROM_CONFIRMACION';

/** 
 * Action que obtiene el estado inicial.
 * @param {any} state
 * @param {any} currentScope
 */
export function GetScreenData(state, currentScope, tarjetas, sesion) {
    LogHelper.In(GetScreenData.name, state, currentScope, tarjetas, sesion);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        _tarjetas = tarjetas;
        _executionContext = sesion.executionContext;
        _routtingState = getState();

        dispatch({ type: GET_SCREEN_DATA, state });

        const parsedState = getState();

        var currentScopeRequest = {
            "UserId": currentScope.UserId,
            "ProductCode": currentScope.ProductCode,
            "ProgramCode": currentScope.ProgramCode
        }

        ConciergeProxy.Execute((data) => _loadNewRequestConfirmationFunctions(data), null, "GETFUNCTIONS", currentScopeRequest);
    }
}

/**
 * 
 */
export function routeToNext() {
    LogHelper.In(routeToNext.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ROUTE_TO_NEXT });
    }
}

/**
 * 
 * @param {any} request
 */
export function routingPrevious(request) {
    LogHelper.In(routingPrevious.name, request);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let params = { request: request };
        routting(params, ROUTE_TO_TARJETAS);
    }
}

/**
 * 
 * @param {any} request
 */
export function routeToCancel(request) {
    LogHelper.In(routeToCancel.name, request);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        let params = { request: request };

        routting(params, ROUTE_TO_CANCEL);

        dispatch({ type: ROUTE_TO_CANCEL });
    }
}

/**
 * 
 * @param {any} request
 */
export function guardarSolicitud(request) {
    LogHelper.In(guardarSolicitud.name, request);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        SolicitudManager.GuardarSolicitud(request, SagasHelper.GetSagasId, ejecutarPorEstado, _executionContext);

        dispatch({ type: SAVE_REQUEST });
    }
}

/**
 * 
 * @param {any} request
 */
export function finalizarSolicitud() {
    LogHelper.In(finalizarSolicitud.name);

    return (dispatch, getState) => {
        _dispatch = dispatch;
        dispatch({ type: ROUTE_TO_VISTA_CLIENTE_FROM_CONFIRMACION });
        $('.modal').modal('hide');
    }
}

/**
 * Reset del state de la pantalla.
 */
export function resetStateSolicitudConfirmacion() {
    LogHelper.In(resetStateSolicitudConfirmacion.name);

    return (dispatch) => {
        _dispatch = dispatch;
        dispatch({ type: RESET_STATE_CONFIRMACION });
    }
}


/* -------------------------------  HELPER FUNCTIONS  ------------------------------- */
function validarLimites(solicitud) {
    LogHelper.In(validarLimites.name, solicitud);

    let valido = true;

    //EMPRESA
    let limiteEmpresa = parseInt(solicitud.client.limit);
    let sumaE = 0;
    for (var i = 0; i < solicitud.enterpriseLimit.length; i++) {
        sumaE += parseInt(solicitud.enterpriseLimit[i].LimiteCompra);
    }

    if (solicitud.newEnterprise.id !== undefined && solicitud.newEnterprise.id < 0) {
        sumaE += parseInt(solicitud.newEnterprise.total);
    }

    if (sumaE > limiteEmpresa) { valido = false; }


    //CUENTAS
    let limiteCuenta = parseInt(solicitud.enterprise.total);
    let sumaC = 0;
    for (var j = 0; j < solicitud.accountLimit.length; j++) {
        if (solicitud.accountLimit[j].EmpresaId === solicitud.enterprise.id) {
            sumaC += parseInt(solicitud.accountLimit[j].Valor);
        }
    }

    if (solicitud.newAccount.id !== undefined && solicitud.newAccount.id < 0) {
        sumaC += parseInt(solicitud.newAccount.limiteDeCompra);
    }

    if (sumaC > limiteCuenta) { valido = false; }


    //TARJETAS
    if (solicitud.account.ModalidadDistribucionLimiteId === 2 || solicitud.account.ModalidadDistribucionLimiteId === null) {
        let sumaT = 0;
        for (var k = 0; k < solicitud.cardsLimit.length; k++) {
            sumaT += parseInt(solicitud.cardsLimit[i].Limite);
        }
        if (sumaT > 100) { valido = false }
    }

    return valido;
}

function _loadNewRequestConfirmationFunctions(data) {
    LogHelper.In(_loadNewRequestConfirmationFunctions.name, data);

    userFeatures = JSON.parse(JSON.stringify(data));

    let solicitudFunctions = JSON.parse(JSON.stringify(data.SOLICITUD));
    let solicitudFunctionsAllowed = [];

    let permissions = {
        components: {
            Pantalla: { Active: false, Locked: false },
            BotonesAnteriorSiguiente: { Active: false, Locked: false },
            BotonDistribuirLimites: { Active: false, Locked: false },
            BotonGuardarBorrador: { Active: false, Locked: false }
        },
        solicitudFunctionsAllowed: {}
    };

    solicitudFunctions.forEach(p => { permissions.solicitudFunctionsAllowed[p.Codigo_Funcion] = true; });

    let _screenData = {};
    let distribution = 0;

    permissions.components.Pantalla.Active = true;
    permissions.components.BotonGuardarBorrador.Active = true;

    if (permissions.solicitudFunctionsAllowed.Consulta == true) {
        permissions.components.BotonesAnteriorSiguiente.Active = true;
    }
    if (permissions.solicitudFunctionsAllowed.Distribucion == true) {
        permissions.components.BotonDistribuirLimites.Active = true;
    }

    _screenData.permissions = permissions;
    _screenData.request = _routtingState;
    _screenData.limitDistributionSuccess = (distribution === 100);
    
    _dispatch({ type: GET_SCREEN_DATA_RESULT, result: _screenData, tarjetas: _tarjetas });
}

function routting(params, option) {
    LogHelper.In(routting.name, params, option);

    params = JSON.stringify(params);

    Mediator.SetEngine1Proxy(Engine1Proxy);
    Mediator.GetNextStep("NuevaSolicitudConfirmacion", option, params, 'Tarjetas', 'SOLICITUD');
}

function ejecutarPorEstado(result, disconectCallback) {
    LogHelper.In(ejecutarPorEstado.name, result, disconectCallback);

    let type;
    let modalId;
    //ESTADO Descripcion
    //1	     Iniciada
    //2	     Completada
    //3	     Error
    //4	     CompletadaConDependencias
    //5	     CompletadaErrores
    //6	     Abortada
    //7	     EnCancelacion
    switch (result.Estado) {
        case 2:
            ClienteManager.ActualizarStateVistaCliente(_tarjetas, _dispatch);
            modalId = "completada";
            break;
        case 3:
            modalId = "error";
            break;
        case 4:
            ClienteManager.ActualizarStateVistaCliente(_tarjetas, _dispatch);
            modalId = "completadaConDependencias";
            break;
        case 5:
            modalId = "error";
            break;
    }
    $("#" + modalId).modal();

    _dispatch({ type: SHOW_SAVE_STATUS, sagaId: result.SagaId, modalId: modalId });
    disconectCallback();
}